import { useEffect } from 'react';

export function useDocumentTitle(clinicName?: string) {
  useEffect(() => {
    if (clinicName && clinicName.trim().length > 0) {
      document.title = `Elva - ${clinicName}`;
    } else {
      document.title = 'Elva';
    }
  }, [clinicName]);
}

export default useDocumentTitle;
